module.exports = __webpack_public_path__ + "img/monthRecordFootBg.073df6e5.jpg";